module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "simple-button",
    class: _vm.disabled ? 'simple-button--disabled' : '',
    attrs: {
      "disabled": _vm.disabled,
      "id": ("simple-button-" + (_vm.text.split(/\s/g).join('')))
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cbab6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/simpleButton/SimpleButton.vue
// module id = 1967
// module chunks = 0